/**
 * @file The client-side main entry point.
 */
import '@babel/polyfill';
import React from 'react';
import { Provider } from 'react-redux';
import { hydrate } from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { AppContainer } from 'react-hot-loader';
import { BrowserRouter } from 'react-router-dom';
import { loadableReady } from '@loadable/component';

import '../styles/app.scss';

import getApolloClient from './boot/apollo.boot';
import getReduxStore from './boot/redux.boot';
import App from './App';
import getLogger from './util/logger';
import { initSentry } from './util/sentry';
import { initPluralize } from './util/pluralize';

const log = getLogger('AppBoot');

const init = () => {
  log.info('init() :: App starts booting...');

  initSentry();
  initPluralize();

  // eslint-disable-next-line no-underscore-dangle
  const initialState = window.__INITIAL_STATE__ || {};
  const apolloClient = getApolloClient();
  const reduxStore = getReduxStore(initialState);

  const renderApp = (AppStore, ApplicationMain) => {
    hydrate(
      <ApolloProvider client={apolloClient}>
        <Provider store={AppStore}>
          <AppContainer>
            <BrowserRouter>
              <ApplicationMain />
            </BrowserRouter>
          </AppContainer>
        </Provider>
      </ApolloProvider>,
      document.getElementById('app'),
    );
  };

  if (module.hot) {
    module.hot.accept('./App', () => {
      renderApp(reduxStore, App);
    });
  }

  loadableReady(() => renderApp(reduxStore, App));
};

init();
